import React from 'react';

import VideoVersioningAgenda from '../components/videoVersioningAgenda';
import VideoVersioningVideo from '../components/videoVersioningVideo';

export default ({ id, isInLiveMode }) => ({
  video: {
    CustomComponent: ({ value }) => <VideoVersioningVideo video={value} />,
  },
  name: {
    type: 'title'
  },
  description: {
    type: 'description'
  },
  ...(isInLiveMode && {
    agenda_items: {
      CustomComponent: () => <VideoVersioningAgenda id={id} />,
    },
  }),
});
